<script setup>
setPageTitle(PageMeta.Messages.Add.Title)
definePage({ meta: PageMeta.Messages.Add.Meta })

import { useMessagesStore } from '@/@vxapp/Messages/useMessagesStore'

const messageStore = useMessagesStore()

const route = useRoute()
const messageData = ref(null)

onMounted(async () => {
  const { message } = await messageStore.fetch(route.params.guid)

  messageData.value = fetchedMessage.message
})

/* ** */
</script>
